var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 190",
    enableBackground: "new 0 0 190 190",
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 274,
    cy: 55.25,
    r: 77.25
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    opacity: 0.4,
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    cx: 48.501,
    cy: 55.25,
    r: 77.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Instructions_and_Tone"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EAEAEA",
    cx: 105.875,
    cy: 100.25,
    r: 77.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000096772696218576756710000002688979764445093040_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#633FDA",
    d: "M131.625,82.671c-1.25,1.144-2.888,1.838-4.643,2.251c0.189-2.258,0.312-4.52,0.358-6.776 c0.135-6.637-0.294-13.256-1.007-19.859c1.693,0.422,3.307,1.412,4.672,2.869c2.601,2.779,3.434,7.07,3.5,10.861 C134.569,75.649,134.392,80.142,131.625,82.671 M41.509,91.149c-3.039-2.852-4.123-7.604-4.678-11.587 c-0.563-4.041,0.102-7.807,2.844-10.971c2.352-2.71,5.555-4.405,8.978-4.687c0.003,0.219,0.007,0.438,0.011,0.659 c0.141,9.524,0.342,19.244,1.832,28.66C47.27,93.466,43.835,93.33,41.509,91.149 M136.241,54.844 c-2.97-2.854-6.89-4.687-10.942-4.911c-0.588-4.275-1.24-8.545-1.901-12.806c-0.092-0.597-0.252-1.285-0.835-1.554 c-0.296-0.136-0.643-0.13-0.972-0.122c-20.081,0.518-39.818,1.454-59.958,1.454c-3.062,0-6.09,0.12-9.143,0.369 c-1.346,0.11-2.863,0.328-3.632,1.357c-0.549,0.736-0.556,1.697-0.543,2.592c0.071,4.842,0.146,9.684,0.217,14.527 c-5.558,0.308-10.929,2.897-14.625,7.073c-4.258,4.813-5.985,10.78-5.19,17.133c0.744,5.937,2.418,12.459,6.832,16.781 c4.535,4.44,10.615,4.919,16.576,4.467c1.271,5.011,3.025,9.891,5.486,14.555c2.003,3.797,4.514,9.717,8.066,12.367 c3.556,2.651,11.401,2.624,12.759,3.295c0.079,1.328,0.706,11.903,0.772,14.186c0.117,3.994,0.545,7.993,0.512,11.987 c-7.234,0.157-13.162,0.3-20.396,0.472c-8.959,0.213-7.44,2.416-6.596,10.047c0.271,2.426-0.961,6.714,1.456,8.477 c0.652,0.476,1.533,0.551,2.361,0.605c22.776,1.494,42.14,1.092,64.838-1.201c0.989-7.584,1.281-15.245,0.869-22.874 c-10.006,0.359-17.761,0.72-27.768,1.081c0.178-10.135,0.545-13.709,0.723-23.845c9.715-0.346,17.211-4.618,21.9-12.502 c4.514-7.588,7.287-15.928,8.794-24.496c4.217-0.546,8.324-1.981,11.491-4.917c4.579-4.246,5.459-11.071,5.255-17.002 C142.441,65.429,140.694,59.122,136.241,54.844"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    d: "M42.951,156.348c-0.471,0-0.948-0.135-1.368-0.419C19.85,141.246,6.875,116.842,6.875,90.649 c0-43.41,35.317-78.728,78.729-78.728c43.408,0,78.726,35.317,78.726,78.728c0,24.537-11.139,47.237-30.562,62.279 c-1.07,0.827-2.605,0.633-3.434-0.437c-0.828-1.068-0.632-2.606,0.437-3.434c18.217-14.107,28.664-35.397,28.664-58.409 c0-40.71-33.121-73.832-73.831-73.832c-40.713,0-73.834,33.122-73.834,73.832c0,24.564,12.17,47.453,32.555,61.224 c1.12,0.757,1.414,2.279,0.658,3.399C44.509,155.971,43.737,156.348,42.951,156.348"
  })))));
};
export default __webpack_public_path__ + "static/media/Icons_Selected_04_Trophy.270694c6.svg";
export { SvgComponent as ReactComponent };